import { Breadcrumb, Tag, Button } from "antd";
import React, { useState } from "react";
import Table, { ColumnType } from "antd/es/table";
import moment from "moment";

import MyPagination from "../../components/Pagination";

import { INotification } from "../../../types/api/notification";
import { useMessageApi } from "../../../provider/AntdNotification";
import { useNotificationList, useUpdateNotificationStatus } from "../../../hooks/api/notification/hooks";

const NotificationTable = () => {
  const [breadcrumb] = useState("Notification");
  const messageApi = useMessageApi();

  const {
    data,
    refetchWithQuery: refetch,
    isFetching,
  } = useNotificationList({
    page: 1,
    limit: 20,
  });

  const { mutate: updateNotificationStatus} =
    useUpdateNotificationStatus({
      onSuccess: () => {
        messageApi.success("All notifications marked as read");
      },
      onError: (error: any) => {
        messageApi.error(error.message);
      },
    });

  const DEFAULT_NUQS_CONFIG = {
    throttleMs: Infinity,
  };

  const qData = data?.qData ?? { page: 1, limit: 20 };

  const columns: ColumnType<INotification>[] = [

     {
      title: "User ID",
      dataIndex: "userId",
    },

    {
      title: "Message",
      dataIndex: "message",
    },
    {
      title: "Reference ID",
      dataIndex: "referenceId",
      render: (r: string) => <Tag color="purple">{r}</Tag>,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status: string) => (
        <Tag color={status === "unread" ? "red" : "green"}>{status}</Tag>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (value: string) => moment(value).format("DD MMM YYYY, h:mm A"),
    },
  ];

  return (
    <div>
      <div className="flex justify-between items-center">
        <h1 className="text-lg sm:text-3xl font-semibold">Notification</h1>

        {/* Mark all read button */}
        <Button
          type="primary"
          disabled={(data?.data?.length ?? 0) === 0}
          onClick={() =>
            updateNotificationStatus({status : "read" , isAll : true} as INotification)
          }
        >
          Mark All as Read
        </Button>
      </div>

      <Breadcrumb
        separator=">"
        items={[{ title: "Dashboard" }, { title: breadcrumb }]}
        className="text-xs sm:text-base my-2 mb-5"
      />

      <Table
        dataSource={data?.data}
        columns={columns}
        rowKey={(item) => item._id ?? ""}
        loading={isFetching}
        pagination={false}
        scroll={{ x: true }}
        size="middle"
        className="custom-rounded-table"
        footer={() => (
          <MyPagination
            qData={qData}
            onChange={refetch}
            total={qData.total}
            DEFAULT_NUQS_CONFIG={DEFAULT_NUQS_CONFIG}
          />
        )}
      />
    </div>
  );
};

export default NotificationTable;
